import $ from 'jquery';

const TABLET_BREAKPOINT = 768;

const nextStepsInit = () => {
    const $sections = $('.s-next-steps');

    if ($sections.length === 0) return;

    $sections.each(function () {
        const $section = $(this);
        const $cards = $section.find('.s-next-steps-card');
        const $progress = $section.find('.s-next-steps-progress');
        const $scrollContainer = $section.find('.s-next-steps-progress-container');
        const cardCount = $cards.length;

        if (cardCount === 0) return;

        // Step activation thresholds (percentage of section scroll)
        const thresholds = [0, 0.3, 0.6];

        // Generate single trail line + step indicators in flex wrappers
        let stepsHTML = '<div class="s-next-steps-trail"><span class="s-next-steps-trail-fill"></span></div>';
        for (let i = 0; i < cardCount; i += 1) {
            const activeClass = i === 0 ? ' is-active' : '';
            stepsHTML += `<div class="s-next-steps-step"><span class="s-next-steps-indicator${activeClass}">${i + 1}</span></div>`;
        }
        $progress.html(stepsHTML);

        // Cache DOM references
        const $indicators = $progress.find('.s-next-steps-indicator');
        const $trailFill = $progress.find('.s-next-steps-trail-fill');
        const $btns = $cards.map(function () { return $(this).find('.s-next-steps-card-btn'); });
        const $header = $section.find('.s-next-steps-header');
        const container = $scrollContainer[0];
        let prevHighestActive = -1;

        const updateStepState = (highestActive, trailPercent) => {
            $trailFill[0].style.width = `${trailPercent}%`;

            if (highestActive !== prevHighestActive) {
                prevHighestActive = highestActive;

                $indicators.each(function (index) {
                    $(this).toggleClass('is-active', index <= highestActive);
                });

                for (let i = 0; i < cardCount; i += 1) {
                    if (i === highestActive) {
                        $btns[i].removeClass('btn-skin-2').addClass('btn-skin-1');
                    } else {
                        $btns[i].removeClass('btn-skin-1').addClass('btn-skin-2');
                    }
                }
            }
        };

        // Mobile: sync indicators with horizontal swipe on progress container
        const onCardsScroll = () => {
            const { scrollLeft } = container;
            const maxScroll = container.scrollWidth - container.clientWidth;
            if (maxScroll <= 0) return;

            const scrollPercent = scrollLeft / maxScroll;
            const highestActive = Math.min(Math.round(scrollPercent * (cardCount - 1)), cardCount - 1);

            updateStepState(highestActive, scrollPercent * 100);
        };

        // Desktop/Tablet: track vertical page scroll through the section
        const updateProgress = () => {
            const sectionTop = $section[0].offsetTop;
            const sectionHeight = $section[0].offsetHeight;
            const scrollTop = window.pageYOffset;
            const viewportHeight = window.innerHeight;

            const scrollableDistance = sectionHeight - viewportHeight;
            if (scrollableDistance <= 0) return;

            const progress = Math.max(0, Math.min(1, (scrollTop - sectionTop) / scrollableDistance));

            let highestActive = 0;
            for (let i = 1; i < thresholds.length; i += 1) {
                if (progress >= thresholds[i]) highestActive = i;
            }

            updateStepState(highestActive, progress * 100);

            // On tablet, also sync horizontal scroll
            if (window.innerWidth < 1024) {
                const maxScrollLeft = container.scrollWidth - container.clientWidth;
                const headerHeight = $header[0].offsetHeight || 0;
                const stickyStart = sectionTop + headerHeight;
                const stickyRange = scrollableDistance - headerHeight;

                if (stickyRange > 0 && scrollTop >= stickyStart) {
                    container.scrollLeft = Math.min((scrollTop - stickyStart) / stickyRange, 1) * maxScrollLeft;
                } else {
                    container.scrollLeft = 0;
                }
            }
        };

        // Bind based on viewport
        const bindEvents = () => {
            $(window).off('scroll.nextSteps');
            $scrollContainer.off('scroll.nextStepsMobile');

            if (window.innerWidth < TABLET_BREAKPOINT) {
                $scrollContainer.on('scroll.nextStepsMobile', onCardsScroll);
                onCardsScroll();
            } else {
                $(window).on('scroll.nextSteps', updateProgress);
                updateProgress();
            }
        };

        bindEvents();

        let resizeTimer;
        $(window).on('resize.nextSteps', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                prevHighestActive = -1;
                bindEvents();
            }, 150);
        });
    });
};

$(() => {
    nextStepsInit();
});
